//prutl-frontend-npm6node14/src/pages/UserManagement.jsx

import React from 'react'
import MembershipList from '../components/membershipManagement/MebershipList'

const MembershipManagement = () => {
  return (
        <div className="userManagementContainer">
      <h1>Membership Management</h1>
      <MembershipList/>
    </div>
  )
}

export default MembershipManagement
